var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m7.802 12.7 5.997 6.007a.998.998 0 0 0 1.41-1.412L9.92 12l5.287-5.297A.999.999 0 0 0 14.498 5c-.26 0-.51.1-.71.29l-5.996 6.008a.998.998 0 0 0 0 1.412l.01-.01Z"
  })));
};
export default SvgChevronLeft;